const styles = ({ links }) => ({
  '&:hover': {
    color: links?.link?.hoverColor,
    textDecoration: 'underline',
  },
  background: 'none',
  border: 'none',
  borderRadius: 0,
  boxShadow: 'none',
  color: links?.link?.color,
  cursor: 'pointer',
  display: 'inline',
  fontSize: 'inherit',
  margin: 0,
  padding: 0,
  textAlign: 'left',
  textDecoration: 'none',
});

export default styles;
